(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HPManualContext = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var ORDER = ['pure', 'plus', 'filter'];
  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function classifyItem(value) {
    var item = normalize(value);
    // Accessories may carry the brand name without being the product.
    if (/^(?:hidra\s*pure\s+)?(garrafa|squeeze)\b/.test(item)) return [];
    var filter = /\b(hidra\s*filter|filter)\b/.test(item);
    var plus = /\b(hidra\s*plus|plus)\b/.test(item);
    var pure = /\b(hidra\s*pure|pure|bastao|capsula|ionizador)\b/.test(item);
    var kit = /\b(kit|combo)\b/.test(item) || /\+|\be\b/.test(item);
    if (filter) {
      // "Kit refil Hidra Filter - Hidra Pure" names the brand, not a Pure stick.
      var combined = /\+|\be\b/.test(item);
      return ORDER.filter(function (key) {
        return key === 'filter' || (combined && (key === 'pure' ? pure : plus));
      });
    }
    if (/\brefil\b/.test(item) || /^(filtro|jarra)\b/.test(item)) return [];
    if (plus && /\bpure\b/.test(item) && kit) return ['pure', 'plus'];
    if (plus) return ['plus'];
    return pure ? ['pure'] : [];
  }
  function resolveProducts(source) {
    var params = source instanceof URLSearchParams ? source : new URLSearchParams(source || '');
    var found = params.getAll('itens').join(',').split(/[,;|]/).flatMap(classifyItem);
    if (!found.length && params.has('prod')) found = classifyItem(params.get('prod'));
    if (ORDER.some(function (key) { return params.has(key + '_q'); })) {
      var invalid = ORDER.some(function (key) {
        if (!params.has(key + '_q')) return false;
        var value = params.get(key + '_q').trim();
        return !/^\d+$/.test(value) || !Number.isSafeInteger(Number(value));
      });
      if (invalid) return [];
      // A legacy order can include Pure/Plus counts and identify Filter in itens.
      // An explicit zero excludes that product even when its name is in itens.
      return ORDER.filter(function (key) {
        return params.has(key + '_q') ? Number(params.get(key + '_q')) > 0 : found.includes(key);
      });
    }
    if (found.length) return ORDER.filter(function (key) { return found.includes(key); });
    return params.has('itens') || params.has('prod') ? [] : ORDER.slice();
  }
  function buildManualUrl(source) {
    var params = source instanceof URLSearchParams ? source : new URLSearchParams(source || '');
    var target = new URLSearchParams({ view: 'manual-de-uso' });
    // An instruction manual does not need customer or email data.
    ['prod', 'q', 'pure_q', 'plus_q', 'filter_q', 'preview_theme_id'].forEach(function (key) {
      if (params.has(key)) target.set(key, params.get(key));
    });
    params.getAll('itens').forEach(function (value) { target.append('itens', value); });
    return '/pages/manual-de-uso-hidra-pure?' + target.toString();
  }
  return { resolveProducts: resolveProducts, buildManualUrl: buildManualUrl };
});
